export enum BIFinishOnBoardingType {

    FinishOB = "Finish OB",
    Leave = "Leave",
    Other = "Other"
}
